// extracted by mini-css-extract-plugin
module.exports = {"content":"EABDKeyToSuccessScreen_content__3feev","footer":"EABDKeyToSuccessScreen_footer__1ifZj"};